export const translations = {
  nl: {
    hero: {
      kicker: "Wij gaan trouwen",
      dateLine: "Vrijdag 4 september 2026",
      timeLine: "18:00 uur",
      place: "Park de Heerlijkheid · Rotterdam",
      scroll: "Ontdek",
    },
    quote: {
      text: "Jij bent mijn grootste zegen.",
      author: "Nurhan & Emre",
    },
    countdown: {
      kicker: "Aftellen",
      title: "Op weg naar ons nieuwe leven samen.",
      days: "Dagen",
      hours: "Uren",
      mins: "Minuten",
      secs: "Seconden",
      done: "Het is zover — we zijn getrouwd!",
    },
    location: {
      kicker: "De plek",
      title: "Park de Heerlijkheid",
      address: "Herikweg 5, 3193 XA Hoogvliet Rotterdam",
      desc: "Vier dit bijzondere moment met ons op deze sfeervolle locatie aan de rand van de stad.",
      button: "Bekijk op Google Maps",
      when: "Vrijdag 4 september 2026 · 18:00 uur",
    },
    rsvp: {
      kicker: "Laat het ons weten",
      title: "Ben je erbij?",
      desc: "We zouden het geweldig vinden als je erbij bent. Laat het ons weten en dan zetten we een stoel voor je klaar.",
      deadline: "Reageer vóór 15 augustus 2026",
      button: "RSVP via WhatsApp",
      waMessage:
        "Hallo! Wij komen graag naar de bruiloft van Nurhan & Emre op 4 september 2026.",
    },
    gift: {
      kicker: "Met liefde",
      title: "Een cadeau",
      desc: "Jouw aanwezigheid is het mooiste geschenk. Wil je ons toch verrassen? Dan is een bijdrage van harte welkom.",
      ibanLabel: "IBAN",
      holder: "t.n.v. Emre & Nur",
      copy: "Kopieer IBAN",
      copied: "Gekopieerd!",
      toast: "IBAN gekopieerd naar klembord",
    },
    footer: {
      text: "Met liefde gemaakt voor onze grote dag",
    },
    actions: {
      addCalendar: "Zet in agenda",
      googleCalendar: "Google Agenda",
      share: "Deel deze dag",
      shareCopied: "Link gekopieerd",
      calendarAdded: "Agenda-bestand gedownload",
      calendarError: "Downloaden mislukt, probeer opnieuw",
      shareText: "Nurhan & Emre trouwen op 4 september 2026 in Rotterdam!",
    },
    guestbook: {
      kicker: "Gastenboek",
      title: "Laat een berichtje achter",
      desc: "Een wens, een felicitatie of een lieve herinnering — we lezen ze allemaal.",
      name: "Je naam",
      namePh: "Voor- en achternaam",
      message: "Je bericht",
      messagePh: "Schrijf hier je wens…",
      submit: "Plaats bericht",
      sending: "Versturen…",
      success: "Bedankt voor je lieve woorden!",
      error: "Er ging iets mis. Probeer het opnieuw.",
      empty: "Wees de eerste die een berichtje achterlaat.",
    },
    travel: {
      kicker: "Reisinfo",
      title: "Zo kom je er",
      carTitle: "Met de auto",
      carDesc: "Neem afrit Hoogvliet (A15). Volg de borden richting Park de Heerlijkheid.",
      parkingTitle: "Parkeren",
      parkingDesc: "Gratis parkeergelegenheid aanwezig direct naast de locatie.",
      transitTitle: "Openbaar vervoer",
      transitDesc: "Metro D naar station Hoogvliet, daarna ca. 10 minuten lopen of met de bus.",
    },
    rsvpForm: {
      open: "Vul het RSVP-formulier in",
      or: "of laat het snel weten via",
      title: "Laat het ons weten",
      subtitle: "We kijken ernaar uit je te zien",
      name: "Je naam",
      namePh: "Voor- en achternaam",
      attending: "Ben je erbij?",
      yes: "Ja, ik kom",
      no: "Helaas niet",
      guests: "Aantal personen",
      phone: "Telefoon (optioneel)",
      note: "Bericht (optioneel)",
      notePh: "Dieetwensen of een lief woordje…",
      submit: "Verstuur RSVP",
      sending: "Versturen…",
      successTitle: "Dankjewel!",
      successYes: "Wat leuk dat je erbij bent. Tot 4 september!",
      successNo: "Jammer dat je er niet bij kunt zijn. We denken aan je!",
      error: "Er ging iets mis. Probeer het opnieuw.",
      nameRequired: "Vul alsjeblieft je naam in.",
    },
    music: { play: "Muziek aan", pause: "Muziek uit" },
    nav: {
      home: "Home",
      countdown: "Aftellen",
      location: "Locatie",
      travel: "Reisinfo",
      guestbook: "Gastenboek",
      kina: "Kına",
    },
    kina: {
      kicker: "Kına Gecesi",
      title: "Istanbul",
      desc: "Onze henna-avond vieren we in Istanbul.",
      button: "www.emrevenur.com",
    },
  },
  tr: {
    hero: {
      kicker: "Evleniyoruz",
      dateLine: "4 Eylül 2026 Cuma",
      timeLine: "Saat 18:00",
      place: "Park de Heerlijkheid · Rotterdam",
      scroll: "Keşfet",
    },
    quote: {
      text: "Sen en büyük şükrümsün.",
      author: "Nurhan & Emre",
    },
    countdown: {
      kicker: "Geri sayım",
      title: "Birlikte yeni hayatımıza doğru.",
      days: "Gün",
      hours: "Saat",
      mins: "Dakika",
      secs: "Saniye",
      done: "Vakit geldi — evlendik!",
    },
    location: {
      kicker: "Mekan",
      title: "Park de Heerlijkheid",
      address: "Herikweg 5, 3193 XA Hoogvliet Rotterdam",
      desc: "Bu özel anı, şehrin kıyısındaki bu huzurlu mekanda bizimle birlikte kutlayın.",
      button: "Google Maps'te aç",
      when: "4 Eylül 2026 Cuma · Saat 18:00",
    },
    rsvp: {
      kicker: "Bize bildir",
      title: "Katılıyor musun?",
      desc: "Aramızda olman bizi çok mutlu eder. Bize bildir, senin için bir yer ayıralım.",
      deadline: "Lütfen 15 Ağustos 2026'ya kadar bildir",
      button: "WhatsApp ile LCV",
      waMessage:
        "Merhaba! 4 Eylül 2026'daki Nurhan & Emre'nin düğününe katılmak istiyoruz.",
    },
    gift: {
      kicker: "Sevgiyle",
      title: "Hediye",
      desc: "Varlığın en güzel hediye. Yine de bizi sevindirmek istersen, katkın için minnettarız.",
      ibanLabel: "IBAN",
      holder: "Emre & Nur adına",
      copy: "IBAN'ı kopyala",
      copied: "Kopyalandı!",
      toast: "IBAN panoya kopyalandı",
    },
    footer: {
      text: "Büyük günümüz için sevgiyle hazırlandı",
    },
    actions: {
      addCalendar: "Takvime ekle",
      googleCalendar: "Google Takvim",
      share: "Bu günü paylaş",
      shareCopied: "Bağlantı kopyalandı",
      calendarAdded: "Takvim dosyası indirildi",
      calendarError: "İndirme başarısız, tekrar dene",
      shareText: "Nurhan & Emre 4 Eylül 2026'da Rotterdam'da evleniyor!",
    },
    guestbook: {
      kicker: "Ziyaretçi defteri",
      title: "Bize bir not bırak",
      desc: "Bir dilek, bir tebrik ya da güzel bir anı — hepsini okuyoruz.",
      name: "Adın",
      namePh: "Ad ve soyad",
      message: "Mesajın",
      messagePh: "Dileğini buraya yaz…",
      submit: "Mesaj gönder",
      sending: "Gönderiliyor…",
      success: "Güzel sözlerin için teşekkürler!",
      error: "Bir şeyler ters gitti. Lütfen tekrar dene.",
      empty: "İlk mesajı bırakan sen ol.",
    },
    travel: {
      kicker: "Ulaşım",
      title: "Nasıl gelinir",
      carTitle: "Araçla",
      carDesc: "Hoogvliet çıkışını (A15) kullanın. Park de Heerlijkheid tabelalarını takip edin.",
      parkingTitle: "Otopark",
      parkingDesc: "Mekanın hemen yanında ücretsiz otopark mevcuttur.",
      transitTitle: "Toplu taşıma",
      transitDesc: "D metrosu ile Hoogvliet istasyonu, ardından yaklaşık 10 dakika yürüyüş veya otobüs.",
    },
    rsvpForm: {
      open: "LCV formunu doldur",
      or: "veya hızlıca haber ver:",
      title: "Bize bildir",
      subtitle: "Seni görmeyi dört gözle bekliyoruz",
      name: "Adın",
      namePh: "Ad ve soyad",
      attending: "Katılıyor musun?",
      yes: "Evet, geliyorum",
      no: "Maalesef gelemiyorum",
      guests: "Kişi sayısı",
      phone: "Telefon (opsiyonel)",
      note: "Mesaj (opsiyonel)",
      notePh: "Diyet tercihleri veya güzel bir not…",
      submit: "LCV Gönder",
      sending: "Gönderiliyor…",
      successTitle: "Teşekkürler!",
      successYes: "Aramızda olacağın için çok mutluyuz. 4 Eylül'de görüşürüz!",
      successNo: "Katılamayacağın için üzgünüz. Seni düşüneceğiz!",
      error: "Bir şeyler ters gitti. Lütfen tekrar dene.",
      nameRequired: "Lütfen adını gir.",
    },
    music: { play: "Müzik aç", pause: "Müzik kapat" },
    nav: {
      home: "Ana sayfa",
      countdown: "Geri sayım",
      location: "Mekan",
      travel: "Ulaşım",
      guestbook: "Defter",
      kina: "Kına",
    },
    kina: {
      kicker: "Kına Gecesi",
      title: "İstanbul",
      desc: "Kına gecemizi İstanbul'da kutluyoruz.",
      button: "www.emrevenur.com",
    },
  },
};
